<section class="c-section--static" *ngIf="vm.selectedChat">
	<div class="c-section__header c-text--center">
		<div class="o-container">
			<div class="o-container">
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v">
						<a *ngIf="!vm.isPrevisit" id="headerLogoMinudoc" class="c-header__logo c-logo c-logo--{{vm.logoSuffix}}"></a>
						<a *ngIf="vm.isPrevisit" id="headerLogoPrevisit" class="c-header__logo c-logo c-logo--previsit c-logo--previsit@up-to-md"></a>
					</div>
				</div>
			</div>
			<!-- Language menu -->
			<nav class="c-nav c-nav--tab-bar" style="z-index: 9999;">
				<div class="o-container">
					<div class="o-grid">
						<div style="padding-right:0px;" class="o-grid__cell o-grid__cell--w-95">
							<div class="c-nav__menu">
								<ul class="c-nav__list">
									<!-- Language menu -->
									<li class="c-nav__item c-nav__dd" [ngClass]="{ 'c-nav__dd--open': vm.isLanguageMenuOpen }">
										<a id="selectedLangMenu" class="c-nav__link c-nav__dd-toggle c-nav__dd-toggle--arrow" (click)="vm.isLanguageMenuOpen = !vm.isLanguageMenuOpen">
											<i class="c-flag c-flag--{{ vm.getLocaleOption(vm.locale).icon }} c-nav__thumb" aria-hidden="true"></i>
											<span id="selectedLangValue" class="c-nav__label c-text c-text--uppercase">{{ vm.getLocaleOption(vm.locale).shortLabel }}</span>
										</a>
										<div class="c-nav__dd-menu">	
											<ul class="c-nav__dd-list">
												<ng-container *ngFor="let language of vm.locales ; let $index=index">
													<li class="c-nav__dd-item" *ngIf="language.locale !== vm.locale" (click)="vm.setLocale(language.locale)">
														<a id="selectLang{{$index}}" href="javascript:void(0)" class="c-nav__dd-link" >
															<i class="c-flag c-flag--{{ language.icon }} c-nav__dd-icon c-nav__thumb" aria-hidden="true"></i>
															<span id="selectLangValue{{$index}}" class="c-text c-text--uppercase">{{ language.shortLabel }}</span>
														</a>
													</li>
												</ng-container>
											</ul>
										</div>
									</li>
								</ul>
							</div>
						</div>
						<div style="padding-left:0px;" class="o-grid__cell o-grid__cell--w-5 o-grid__cell--center u-hidden@up-to-md">
							<button id="logoutButton" (click)="logoutWithConfirmation($event)" type="button" style="height:40px;" class="c-button c-button--tp c-button--icon u-no-pv u-no-p@up-to-md">
								<i aria-hidden="true" class="o-icon o-icon--cancel c-text c-text--main c-text--lg u-no-mr" title="{{ 'Components.Header.Button.Log_Out' | translate }}"></i>
								<span class="u-sr-only">{{ 'Components.Header.Button.Log_Out' | translate }}</span>
							</button>
						</div>
					</div>
				</div>
			</nav>
		</div>
	</div>

	<div class="o-grid__cell o-grid__cell--w-fit o-grid__cell--flex o-grid__cell--center@md-and-up u-no-p o-grid__cell--o2@up-to-md">
		<main class="o-container c-container">
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--w-100">
					<div class="o-grid o-grid--bottom o-grid--wrap u-osb-lg">
						<div class="o-grid__cell u-no-p">
							<p id="selectedChatUserName" class="c-text c-text--heading c-text--xl" *ngIf="vm.selectedChat">
								{{ vm.selectedChat?.privateChatFriend?.firstname }} {{ vm.selectedChat?.privateChatFriend?.lastname }}
							</p>
						</div>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up u-no-p u-ost-md@up-to-md u-hidden@up-to-md">
							<a id="avTestButton" href="{{ vm.avTestUrl }}" target="_blank" class="c-button c-button--s2 c-button--fit">{{ 'How_It_Works.Item5-2' | translate }}</a>
						</div>
					</div>
				</div>
			</div>
			<div class="o-grid o-grid--center-h">
				<div class="o-grid o-grid--bottom o-grid__cell--w-100">
					<div class="o-grid__cell o-grid__cell--w-100" *ngIf="vm.selectedChat">
						<card-chat [(chat)]="vm.selectedChat"></card-chat>
					</div>
				</div>
			</div>
			<loader-overlay *ngIf="vm.loading"></loader-overlay>
		</main>
	</div>
</section>
